export const contact = {
  whatsappNumber: '+1 715 201 8490',
  whatsappHref: 'https://wa.me/17152018490',
  videoCallHref:
    'https://wa.me/17152018490?text=' +
    encodeURIComponent('Quiero agendar una consulta por videollamada'),
  headerPhone: '+1 650 676 8112',
  headerPhoneHref: 'tel:+16506768112',
  footerPhone: '+1 650 550 9019',
  footerPhoneHref: 'tel:+16505509019',
  email: 'conjurosamarres4@gmail.com',
  location: 'Templo de Ayuda, La Luz del Mundo — Los Ángeles, California',
}

export const navLinks = [
  { label: 'Trabajos y Servicios', href: '#servicios' },
  { label: 'Términos y Condiciones', href: '#terminos' },
  { label: 'Políticas', href: '#politicas' },
]

export const emotionalQuestions = [
  '¿Sientes que el amor que deseas está cada vez más lejos?',
  '¿Has intentado todo para recuperar a tu pareja?',
  '¿Buscas tomar las riendas de tu camino amoroso?',
  '¿Sientes bloqueos energéticos que impiden tu sanación?',
]

export interface ServiceColumn {
  title: string
  kicker: string
  image: string
  imageAlt: string
  items: string[]
}

export const serviceColumns: ServiceColumn[] = [
  {
    kicker: 'Unión y reconciliación',
    title: 'Amarres y Hechizos Reales',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/d4673724-a04c-47bb-9922-882640069c66.jpg',
    imageAlt: 'Altar de amor con figuras de ángeles, velas doradas y rosas rojas',
    items: [
      'Rituales para enamorar a la persona amada',
      'Recuperar a quien se fue de tu vida',
      'Superar la presencia de terceras personas',
      'Amarres sexuales y de pasión',
      'Amarres de parejas del mismo sexo',
      'Rituales para despojar maldiciones',
    ],
  },
  {
    kicker: 'Limpieza y protección',
    title: 'Conjuros y Alejamientos',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/2860783c-8116-41ad-9801-0deda1fba95b.jpg',
    imageAlt: 'Altar ritual oscuro con figuras talladas, calavera y velas negras',
    items: [
      'Separar terceras personas de tu relación',
      'Alejar vicios y adicciones',
      'Destrucción de brujería y trabajos oscuros',
      'Limpieza y sanación espiritual',
      'Atraer prosperidad y abundancia',
      'Numerología y lectura de tarot',
      'Ritual de unión de almas',
    ],
  },
]
